export default function (steps, currentStep, labels) {
    const array = []
    steps.forEach((step) => {
        if (!step.hidden) {
            array.push({
                title: labels[step.label],
                number: step.step,
                active: step.step === currentStep
            })
        }
    })
    return array
}
